// removed by extract-text-webpack-plugin
module.exports = {"link":"_1hu-E","root":"_2SZeE","title":"_154Ps","bold":"qjeVC","list":"_1TGgF","listItem":"TboJA"};